import React from "react";

import PropTypes from "prop-types";

function TabBar({ items, activeItem, onChange }) {
  const click = (item) => {
    if (item.key !== activeItem) {
      onChange(item.key);
    }
  };

  return (
    <ul className="flex items-center space-x-8">
      {items.map((item) => {
        const isActive = item.key === activeItem;
        let classNames = null;

        if (isActive) {
          classNames = "font-[OmnesMedium] text-secondary cursor-pointer";
        } else {
          classNames = "font-[OmnesMedium] text-gray-300 cursor-pointer";
        }
        return (
          <li
            key={item.key}
            onClick={() => click(item)}
            className={`${classNames} flex justify-center font-bold`}
          >
            {item.title}
            {item.notifs > 0 && (
              <div className="text-white font-bold text-[10px] bg-danger w-3 h-3 text-center rounded-full flex items-center justify-center">
                <div>{item.notifs}</div>
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
}

TabBar.propTypes = {
  items: PropTypes.array.isRequired,
  activeItem: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TabBar;
